export const iconFontAwesomeEditingGrip = (
	<i className="fa-solid fa-grip"></i>
);
